import "core-js/stable";
import "regenerator-runtime/runtime";
import moment from "moment";
import 'select2';

import ComponentFactory from './classes/ComponentFactory';
import TrashCalculator from './classes/trash_calculator/TrashCalculator';
import Parking from './classes/Parking';
import Trash from './classes/Trash';

import Accordion from './classes/components/Accordion';
import Breadcrumb from './classes/components/Breadcrumb';
import FormFilter from './classes/components/FormFilter';
import FormAjax from './classes/components/FormAjax';
import FormItemCondition from './classes/components/FormItemCondition';
import Gallery from './classes/components/Gallery';
import Sidebar from './classes/components/Sidebar';
import Slider from './classes/components/Slider';
import Menu from './classes/components/Menu';
import Modal from './classes/components/Modal';
import Ads from './classes/components/Ads';
import Timeago from './classes/components/Timeago';
import Tooltip from './classes/components/Tooltip';
import Search from './classes/components/Search';
import KeywordSuggest from './classes/components/KeywordSuggest';
import Realtime from './classes/components/Realtime';
import ViewMore from './classes/components/ViewMore';
import IntranetBus from './classes/components/IntranetBus';
import Ascenseur from './classes/components/Ascenseur';
import WaitingLines from './classes/components/WaitingLines';
import Tabs from './classes/components/Tabs';
import Walkthrough from './classes/components/Walkthrough';
import Pikaday from 'pikaday';
import FloatingHelper from "./classes/components/FloatingHelper";
import Plyr from 'plyr';
import Accessibility from "./classes/components/Accessibility";
import CookieBanner from "./classes/components/CookieBanner";
import Flipbook from "./classes/components/Flipbook";
import Liveticker from "./classes/components/Liveticker";

(function ($) {


  new ComponentFactory($);
  ComponentFactory.register('Accessibility', Accessibility);
  ComponentFactory.register('Accordion', Accordion);
  ComponentFactory.register('Breadcrumb', Breadcrumb);
  ComponentFactory.register('FormFilter', FormFilter);
  ComponentFactory.register('FormAjax', FormAjax);
  ComponentFactory.register('FormItemCondition', FormItemCondition);
  ComponentFactory.register('Gallery', Gallery);
  ComponentFactory.register('Sidebar', Sidebar);
  ComponentFactory.register('Slider', Slider);
  ComponentFactory.register('Menu', Menu);
  ComponentFactory.register('Modal', Modal);
  ComponentFactory.register('Ads', Ads);
  ComponentFactory.register('Timeago', Timeago);
  ComponentFactory.register('Tooltip', Tooltip);
  ComponentFactory.register('Search', Search);
  ComponentFactory.register('KeywordSuggest', KeywordSuggest);
  ComponentFactory.register('Realtime', Realtime);
  ComponentFactory.register('ViewMore', ViewMore);
  ComponentFactory.register('IntranetBus', IntranetBus);
  ComponentFactory.register('Ascenseur', Ascenseur);
  ComponentFactory.register('WaitingLines', WaitingLines);
  ComponentFactory.register('Tabs', Tabs);
  ComponentFactory.register('Walkthrough', Walkthrough);
  ComponentFactory.register('FloatingHelper', FloatingHelper);
  ComponentFactory.register('CookieBanner', CookieBanner);
  ComponentFactory.register('Flipbook', Flipbook);
  ComponentFactory.register('Liveticker', Liveticker);

  if ($('.parking-controller').length > 0 || $('.parking-data').length > 0 || $('.parking-full').length > 0) {
    new Parking($);
  }

  if ($('.trash-controller').length > 0) {
    new Trash($);
  }

  if ($('.trash-calculator-controller').length > 0) {
    new TrashCalculator('.trash-calculator');
  }

  /*AUDIO*/
  const player = new Plyr(document.querySelector('.js-audio-player'), {
    settings: []
  });

  //get all image of .image-orientation-detection
  const orientations = jQuery('.image-orientation-detection');

  //Loop on images and check orientation after load using jquery
  orientations.each(function (index, orientation) {


    const element = jQuery(orientation).find('img')[0];

    if (element.naturalWidth > element.naturalHeight) {
      jQuery(orientation).addClass('landscape');
    } else {
      jQuery(orientation).addClass('portrait');
    }

    jQuery(orientation).find('img').on('load', function () {
      jQuery(orientation).removeClass('landscape');
      jQuery(orientation).removeClass('portrait');
      if (this.naturalWidth > this.naturalHeight) {
        jQuery(orientation).addClass('landscape');
      } else {
        jQuery(orientation).addClass('portrait');
      }
    });


  });

  //If find #block-id-children-list-block, remove #block-vdl-children-list-block
  if (jQuery('.paragraph.flexible-blocks .cards-wrapper').length > 0) {
    jQuery('#block-vdl-children-list-block').remove();
  }


  /*ACTION*/

  $(window).click(function () {
    //Hide the menus if visible
    $('button.action-share').attr('aria-expanded', false);
  });


  $('button.action-share').on('click', function (event) {

    var open = ($(this).attr('aria-expanded') == 'false') ? true : false;
    console.log(open);

    $(this).attr('aria-expanded', open);
    event.stopPropagation();
  });

  /*PIKADAY*/

  if ($('#hafas-datepicker').length > 0) {
    var picker = new Pikaday({
      field: $('#hafas-datepicker')[0],
      format: 'DD.MM.YYYY',
    });
  }

  if ($('#edit-start-date').length > 0) {
    var picker = new Pikaday({
      field: $('#edit-start-date')[0],
      onSelect: function () {
        //document.getElementById("controller-form").submit();
      },
      format: 'DD.MM.YYYY',
    });
  }

  if ($('#edit-date').length > 0) {
    var picker = new Pikaday({
      field: $('#edit-date')[0],
      onSelect: function () {
        //document.getElementById("controller-form").submit();
      },
      format: 'DD.MM.YYYY',
    });
  }

  if ($('#edit-date-end').length > 0) {
    var picker = new Pikaday({
      field: $('#edit-date-end')[0],
      onSelect: function () {
        //document.getElementById("controller-form").submit();
      },
      format: 'DD.MM.YYYY',
    });
  }

  $('input.pikaday').each(function (index, element) {
    $(element)[0].value = moment().format('DD.MM.YYYY');
    var picker = new Pikaday({
      field: $(element)[0],
      format: 'DD.MM.YYYY',
    });
  });

  /* LIVEFILTER */
  if ($('.intranet-accordion').length > 0) {
    $('.intranet-accordion').each(function () {
      var $this = $(this);
      var search = $this.find('.livefilter');

      if (search) {
        $this.find('.documents').liveFilter(search, '.documents-item', {
          filterChildSelector: '.documents-item-title'
        });
      }
    });
  }

  // Add class to body when scroll y > 0
  $(window).scroll(function () {
    if ($(this).scrollTop() > 0) {
      $('body').addClass('scroll');
    } else {
      $('body').removeClass('scroll');
    }
  });



  /*Water incidents*/
  $('.water-incident-frontpage .close-button').on('click', function () {
    $('.water-incident-frontpage').remove();
  });

  /*TYPEAHEAD*/

  $('.typeahead').each(function () {

    //return false;
    var ta = $(this);

    var typeahead = new Bloodhound({
      datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
      queryTokenizer: Bloodhound.tokenizers.whitespace,
      prefetch: '/hafas-suggest',
      remote: '/hafas-suggest?q=%QUERY',

    });

    typeahead.initialize();

    ta.typeahead(null, {
      name: 'typeahead',
      displayKey: 'value',
      source: typeahead.ttAdapter(),
      minLength: 0,
      limit: 10
    });

    ta.on("typeahead:opened", function () {
      var initial = ta.val(),
        ev = $.Event("keydown");
      ev.keyCode = ev.which = 40;
      $(this).trigger(ev);
      if (ta.val() != initial) ta.val("");
      return true
    });

    ta.on("typeahead:autocompleted", function () {
    });
  });

  $('.tt-dropdown-menu').bind('DOMNodeInserted', function (e) {
    $(e.target).find('.tt-suggestion').children('p').addClass('needsclick');
  });

  $("input[name='S']").on('typeahead:selected', function (e, datum) {
    $("input[name='REQ0JourneyStopsS0ID']").val(datum.id);
    $("input[name='REQ0JourneyStopsS0G']").val(datum.value);
  });

  $("input[name='Z']").on('typeahead:selected', function (e, datum) {
    $("input[name='REQ0JourneyStopsZ0ID']").val(datum.id);
    $("input[name='REQ0JourneyStopsZ0G']").val(datum.value);
  });

  $('#showTranscription').on('click', function () {
    $(this).parent().toggleClass('open');
  });

  var elements = document.querySelectorAll('input,select,textarea');
  var flag = false;
  for (var i = elements.length; i--;) {
    elements[i].addEventListener('invalid', function (e) {
      if (!flag) {
        flag = true;
        if (($(e.currentTarget).offset().top < $('body').scrollTop() + 170) && $(window).width() > 768) {
          $('html, body').animate({
            scrollTop: ($(e.currentTarget).offset().top - 170)
          }, 500).bind(this);
        }
      }
      setTimeout(function () {
        flag = false;
      }, 200);
    });
  }

  $('.show-search').on('click', function (e) {
    e.preventDefault();
    $('.controller-header').toggleClass('open');
  });

  $('.glossary-header-item a').on('click', function (e) {
    $('html, body').animate({
      scrollTop: $($(e.currentTarget).attr('href')).offset().top - 150
    }, 500).bind(this);
  });

  if (!Modernizr.objectfit) {
    $('.header-background').css('background-image', 'url(' + $('.header-background').find('img').attr('src') + ')');

    $('.media .media-image figure').each(function () {
      $(this).css('background-image', 'url(' + $(this).find('img').attr('src') + ')');
      $(this).find('img').css({'opacity': 0});
    });

    $('.panel-node-full figure').each(function () {
      $(this).css('background-image', 'url(' + $(this).find('img').attr('src') + ')');
      $(this).find('img').css({'opacity': 0});
    });

    $('.card-header-image > figure').each(function () {
      $(this).css('background-image', 'url(' + $(this).find('img').attr('src') + ')');
      $(this).find('img').css({'opacity': 0});
    });
    $('.card-header > figure').each(function () {
      $(this).css('background-image', 'url(' + $(this).find('img').attr('src') + ')');
      $(this).find('img').css({'opacity': 0});
    });

    $('.parking-teaser-wide .panel-image, .parking-teaser .panel-image').each(function () {
      var url = $(this).find('img').attr('src');
      if ($('.intranet-reader').length > 0) {
        url = $(this).find('img').attr('tmpsrc');
      }
      if (url) {
        $(this).css({'background-image': 'url(' + url + ')', 'background-size': 'cover'});
        $(this).find('img').remove();
      }

    });

  }

  /*Accessibility title*/
  if ($('.controller-form').length > 0) {
    let titleParts = [$('.block-page-title h1').text()];
    $('.controller-form > .js-form-item, .controller-form > fieldset').each(function (index, element) {
      let label = $(element).find('> label, > legend').text();

      if ($(element).find('.form-item-select').length > 0) {
        if ($(element).find('.form-item-select option:selected').index() > 0) {
          titleParts.push(label + ' ' + $(element).find('.form-item-select option:selected').text());
        }
      }

      if ($(element).find('.js-form-type-radio').length > 0) {
        if ($(element).find('.js-form-type-radio input:checked').parent().index() > 0) {
          titleParts.push(label + ' ' + $(element).find('.js-form-type-radio input:checked').parent().text());
        }
      }

      if ($(element).find('.form-search').length > 0){
        console.log('search exist');
        if ($(element).find('.form-search').val() != '') {
          titleParts.push(label + ' "' + $(element).find('.form-search').val()+'"');
        }

      }


    });

    if ($('nav.pager').length > 0) {
      titleParts.push('Page ' + $.trim($('nav.pager li.is-active').index()));
    }

    let titleString = titleParts.join(', ');
    titleString = titleString.substring(0, 1).toUpperCase() + titleString.substring(1, titleString.length).toLowerCase();

    document.title = titleString + ' | Ville de Luxembourg';
    console.log('title changed to ' + document.title);
  }


  /*Table*/
  $('.paragraph-text table').each(function (index, element) {
    if (!$(element).parent().hasClass('tablefield-wrapper')) {
      $(element).wrap('<div class="tablefield-wrapper"></div>');
    }
  });


  /*HAFAS*/

  setTimeout(function () {
    $('#block-vdl-main-menu a').each(function (index, element) {
      $(element).removeAttr('target');
    })
  }, 1000);

  setTimeout(function () {
    $("body.hafas a[href*=vdl]").each(function (index, element) {
      $(element).removeAttr('target');
    });
  }, 1000);

  setTimeout(function () {
    $("body.hafas .block-footer-btn").find('a').attr('href', 'https://www.vdl.lu/contact#7105');
  }, 1000);

  /*REMOVE PRINT IF HYGIENE IFRAME*/
  if ($('iframe[src*="https://service.vdl.lu/hygiene/calendrier_des_collectes/"]').length > 0) {
    $('.actions li:last-child').remove();
  }

  /*CONTACT*/
  if (window.location.pathname.indexOf('contact') > -1) {
    if (window.location.hash) {
      if (window.location.hash != '') {
        $('select.service option[value="' + window.location.hash.replace('#', '') + '"]').prop('selected', true);
        $('select.service').change();
      }
    }
    if (window.location.search) {
      if (window.location.search != '') {
        $('select.service option[value="' + window.location.search.replace('?', '') + '"]').prop('selected', true);
        $('select.service').change();
      }
    }
  }

  /* FORM */
  $('#unsubscribeForm').submit(function () {
    if (_paq && $('#email').val().length > 0) {
      _paq.push(['trackEvent', 'Newsletter', "Unsubscribe"]);
    }
  });

  /*MAP*/

  // Not the maps that already fill the window: there is nothing to enlarge
  // there, and the link would land in the middle of the viewer.
  $('iframe[src*="maps"]').not('.map-viewer iframe').each(function (index, element) {
    var iframeWrap = $('<div class="iframe-map"></div>');
    $(element).wrap(iframeWrap);
    var fullscreenCloseButton = $('<a href="#" class="fullscreen-close-button">Reduire la carte</a>');
    var fullscreenButton = $('<a href="#" class="fullscreen-button">Agrandir la carte</a>');

    fullscreenButton.on('click', function (e) {
      $(this).parent().addClass('fullscreen');
    });
    fullscreenCloseButton.on('click', function (e) {
      closeIframes();
    });
    fullscreenCloseButton.insertBefore(element);
    fullscreenButton.insertAfter(element);
  });

  function closeIframes() {
    $('.iframe-map.fullscreen .fullscreen-button').focus();
    $('.iframe-map.fullscreen').removeClass('fullscreen');
  }

  $(document).keyup(function (e) {
    if (e.keyCode == 27) {
      closeIframes();
    }
  });

  $('input[name=email]').on('change', function () {

    $(this).val($(this).val().replace(/ /g, ''));
  });

  if ($('.controller-wide .controller-header').length > 0) {
    $('.alert').addClass('bg-white');
  }
  if ($('.cta-item-wrapper:first-child').length > 0) {
    $('.alert').addClass('bg-white');
  }

  $('.js-webform-type-radios.required, .js-webform-type-webform-radios-other.required').each(function () {
    $(this).find('input[type="radio"]').attr({'required': 'required', 'aria-required': 'true'});
  });

  $('.badge.lang-switch').on('click', function (e) {
    e.preventDefault();
    var url = $(this).attr('data-url');
    window.open(url, '_blank');
  });

  jQuery('.lang-switch').find('button').on('click', function () {
    if (jQuery(this).hasClass('active')) {
      jQuery(this).attr('aria-expanded', 'false');

      jQuery(this).removeClass('active');

      if (jQuery('.overlay').hasClass('show')) {
        jQuery('.overlay').removeClass('show');
      }
    } else {

      jQuery(this).attr('aria-expanded', 'true');

      jQuery(this).addClass('active');

      if (!jQuery('.overlay').hasClass('show')) {
        jQuery('.overlay').addClass('show');
      }
    }
  });

  jQuery('.overlay').on('click', function () {
    if (jQuery('.lang-switch').find('button').hasClass('active')) {
      jQuery('.lang-switch').find('button').removeClass('active');
      jQuery(this).removeClass('show');
    }
  });

  if (jQuery('#asfGA').length > 0) {
    //get hash from url
    jQuery('#asfGA').attr('src', jQuery('#asfGA').data('src') + window.location.hash);
    jQuery('header').addClass('tiny');
  }

  jQuery('.spicker').each(function (index, element) {
    var ph = jQuery(this).attr('placeholder');
    jQuery(this).select2({
      placeholder: ph,
      language: jQuery(this).attr('lang')
    });
  });

  /*Search bus line*/


  $('#line_search').closest('form').on('submit', function (e) {
    e.preventDefault();
    var count = 0;
    count = $('.bus-line-teaser:visible').length;
    $('.count').text(count);
    $('.count').focus();
  });

  /*Water Incidents*/

  $('.water-incidents .card').each(function (index, card) {
    $(card).find('.open').click(function (e) {
      e.preventDefault();
      $(card).addClass('open');
    });

    $(card).find('.close').click(function (e) {
      e.preventDefault();
      $(card).removeClass('open');
    });

  });


  /*Matomo Tracker*/

  //ICI
  if (jQuery('body').hasClass('is-front')) {

    const search_trigger = document.querySelector('.search_trigger');
    if (search_trigger) {
      let searchTriggerTrack = false;

      search_trigger.addEventListener('click', function (e) {
        if (!searchTriggerTrack) {
          console.log('Search');
          _paq.push(['trackEvent', 'Home', 'HomeClick', "Search"]);
          searchTriggerTrack = true;
        }
      });
    }

    const blockThemeProfileButton = document.querySelector('[data-modal-launcher="block-theme-profile"]');
    if (blockThemeProfileButton) {
      let blockThemeProfileTrack = false;
      blockThemeProfileButton.addEventListener('click', function (e) {
        if (!blockThemeProfileTrack) {
          console.log('PlusButton');
          _paq.push(['trackEvent', 'Home', 'HomeClick', "PlusButton"]);
          blockThemeProfileTrack = true;
        }
      });
    }

    const infoTrafficBlock = document.getElementById('block-info-traffic-frontpage-block');
    let infoTrafficBlockTrack = false;

    const profileBlock = document.getElementById('block-profile-block');
    let profileBlockTrack = false;

    const newsBlock = document.getElementById('block-news-frontpage-block');
    let newsBlockTrack = false;

    const newsletterBlock = document.querySelector('.block-newsletter');
    let newsletterBlockTrack = false;

    const socialBlock = document.getElementById('block-socials-frontpage-block');
    let socialBlockTrack = false;

    const networkBlock = document.getElementById('block-networks-partnerships-frontpage-block');
    let networkBlockTrack = false;

    const cityWebsitesBlock = document.querySelector('.block-web-city');
    let cityWebsitesBlockTrack = false;


    const footerBlock = document.querySelector('footer');
    let footerBlockTrack = false;


    document.addEventListener('scroll', function () {


      if (isInViewport(infoTrafficBlock) && !infoTrafficBlockTrack) {
        console.log('Info Traffic Block is visible');
        _paq.push(['trackEvent', 'Home', 'HomeScroll', "TrafficBlock"]);
        infoTrafficBlockTrack = true;
      }

      if (isInViewport(profileBlock) && !profileBlockTrack) {
        console.log('Profile Block is visible');
        _paq.push(['trackEvent', 'Home', 'HomeScroll', "ProfileBlock"]);
        profileBlockTrack = true;
      }

      if (isInViewport(newsBlock) && !newsBlockTrack) {
        console.log('News Block is visible');
        _paq.push(['trackEvent', 'Home', 'HomeScroll', "NewsBlock"]);
        newsBlockTrack = true;
      }

      if (isInViewport(newsletterBlock) && !newsletterBlockTrack) {
        console.log('Newsletter Block is visible');
        _paq.push(['trackEvent', 'Home', 'HomeScroll', "NewsletterBlock"]);
        newsletterBlockTrack = true;
      }


      if (isInViewport(socialBlock) && !socialBlockTrack) {
        console.log('Social Block is visible');
        _paq.push(['trackEvent', 'Home', 'HomeScroll', "SocialBlock"]);
        socialBlockTrack = true;
      }

      if (isInViewport(networkBlock) && !networkBlockTrack) {
        console.log('Network Block is visible');
        _paq.push(['trackEvent', 'Home', 'HomeScroll', "NetworkBlock"]);
        networkBlockTrack = true;
      }

      if (isInViewport(cityWebsitesBlock) && !cityWebsitesBlockTrack) {
        console.log('City Website Block is visible');
        _paq.push(['trackEvent', 'Home', 'HomeScroll', "CityWebsitesBlock"]);
        cityWebsitesBlockTrack = true;
      }

      if (isInViewport(footerBlock) && !footerBlockTrack) {
        console.log('Footer Block is visible');
        _paq.push(['trackEvent', 'Home', 'HomeScroll', "FooterBlock"]);
        footerBlockTrack = true;
      }


    }, {
      passive: true
    });


  }

}(jQuery));

function isInViewport(el) {
  if (!el) return false;
  const rect = el.getBoundingClientRect();

  //return ((rect.top - document.documentElement.clientHeight/2) <= 0);

  //return ((rect.top - document.documentElement.clientHeight) <= 0);

  return ((rect.top - document.documentElement.clientHeight / 2) <= 0) || (((rect.top - document.documentElement.clientHeight) <= 0) && ((rect.top + (rect.height) - document.documentElement.clientHeight) <= 0));

}

/*PAP*/
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.pap-item').forEach(group => {
    const header = group.querySelector('.pap');

    header.addEventListener('click', () => toggleGroup(group));
    header.addEventListener('keydown', e => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggleGroup(group);
      }
    });
  });

  function toggleGroup(group) {
    const expanded = group.getAttribute('aria-expanded') === 'true';
    group.setAttribute('aria-expanded', String(!expanded));

    group.querySelectorAll('.pap-files').forEach(row => {
      row.hidden = expanded;
    });
  }

  const legend = document.querySelector('[data-legend-pap]');
  if (!legend) return;

  const btn = legend.querySelector('.legend-pap__toggle');
  const content = legend.querySelector('.legend-pap__content');
  const chevron = btn.querySelector('.legend-pap__chevron');

  const labelShow = btn.dataset.labelShow;
  const labelHide = btn.dataset.labelHide;

  btn.addEventListener('click', () => {
    const expanded = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', String(!expanded));
    content.hidden = expanded;
    btn.firstChild.nodeValue = expanded ? ` ${labelShow}` : ` ${labelHide}`;
    btn.appendChild(chevron);
  });
});
